import { Grid, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { CheckboxInput, TextInput } from './Inputs';
import FormattedMessages from '../../../../messages/admin/CustomerProfileMessages';
import { formatDate } from '../../../../utils/dates';

const Agreements = ({ profile, highlighted, onChange }) => {
  const [agreements, setAgreements] = useState({});

  useEffect(() => {
    setAgreements(profile?.agreements || {});
    console.log('agreements', profile?.agreements);
  }, [profile]);

  const handleInputChange = (name, value) => {
    const newValue = { ...agreements };
    newValue[name].value = value;

    if (name === 'service_agreement_agreed') {
      newValue.service_agreement_date.value = value ? new Date() : '';
    }

    setAgreements(newValue);
    onChange('agreements', newValue);
  };

  return (
    <Grid container spacing={10} sx={{ width: '100%' }}>
      {/* Left Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          <CheckboxInput
            name="read_compliance_agreements"
            label={FormattedMessages.tcpa}
            checked={!!agreements.read_compliance_agreements?.value}
            required={agreements.read_compliance_agreements?.required}
            onChange={handleInputChange}
            tooltip={FormattedMessages.tcpaTooltip}
            highlighted={highlighted}
          />

          <CheckboxInput
            name="filled_truthfully"
            label={FormattedMessages.truth}
            checked={!!agreements.filled_truthfully?.value}
            required={agreements.filled_truthfully?.required}
            onChange={handleInputChange}
            tooltip={FormattedMessages.truthTooltip}
            highlighted={highlighted}
          />

          <CheckboxInput
            name="service_agreement_agreed"
            label={FormattedMessages.privacy}
            checked={!!agreements.service_agreement_agreed?.value}
            required={agreements.service_agreement_agreed?.required}
            onChange={handleInputChange}
            tooltip={FormattedMessages.privacyTooltip}
            highlighted={highlighted}
          />

          <TextInput
            name="service_agreement_date"
            type="date"
            label={FormattedMessages.privacyOn}
            value={formatDate(agreements.service_agreement_date?.value)}
            disabled
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Agreements;
